import React from "react";
import Logo from "../../../../Assets/Logo6D.png";
import CertificateImage from "../../../../Assets/CertificateImg.png";
import SignatureImage from "../../../../Assets/signature.png";
import Barcode from "react-barcode";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../Redux/UserSlice";
import { cookies } from "../../../../Controller/Common";

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const monthShortNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthShortNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};
const CertificateCanvas: React.FC<{
  courseName?: string;
  name?: string;
  date?: string;
  certificateId?: any;
}> = ({ courseName, name, date, certificateId }) => {
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const userName =
    useSelector((state: RootState) => state.user.userName) ??
    cookies.get("FirstName");

  React.useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");

    if (canvas && context) {
      const dpi = 80;
      const widthInches = 29.7 * 0.393701;
      const heightInches = 21 * 0.393701;
      canvas.width = widthInches * dpi;
      canvas.height = heightInches * dpi;
      const img = new Image();
      img.src = CertificateImage;
      img.onload = () => {
        context.drawImage(img, 0, 0, canvas.width, canvas.height);

        const logo = new Image();
        logo.src = Logo;
        logo.onload = async () => {
          const desiredWidth = 130;
          const aspectRatio = logo.width / logo.height;
          const desiredHeight = desiredWidth / aspectRatio;
          const logoYPosition = 190;
          context.drawImage(
            logo,
            canvas.width / 2 - desiredWidth / 2,
            logoYPosition,
            desiredWidth,
            desiredHeight
          );

          let textYPosition = logoYPosition + desiredHeight + 30;

          context.font = "600 32px Poppins";
          context.fillStyle = "#7c7b63";
          context.textAlign = "center";
          context.fillText(
            "CERTIFICATE OF COMPLETION",
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 30;
          context.font = "400 16px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(
            "This is presented to",
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 40;
          context.font = "500 38px  Teko";
          context.fillStyle = "#ef1c36";
          context.fillText(
            (name || "STUDENT NAME").toUpperCase(),
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 35;
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(
            "for the successful completion of",
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 30;
          context.font = "500 16px Poppins";
          context.fillStyle = "#ef1c36";
          context.fillText(
            (courseName || "COURSE TITLE").toUpperCase(),
            canvas.width / 2,
            textYPosition
          );

          textYPosition += 30;
          const thirdPart = "on";
          const firstPart = `${formatDate(date || new Date().toISOString())} `;
          const secondPart = "in 6D Platform.";
          context.font = "400 14px Poppins";
          const thirdPartWidth = context.measureText(thirdPart).width;
          context.font = "500 16px Poppins";
          const firstPartWidth = context.measureText(firstPart).width;
          context.font = "400 14px Poppins";
          const secondPartWidth = context.measureText(secondPart).width;
          const totalWidth = thirdPartWidth + firstPartWidth + secondPartWidth;
          const startX = (canvas.width - totalWidth) / 2;
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(thirdPart, startX, textYPosition);
          context.font = "500 16px Poppins";
          context.fillStyle = "#ef1c36";
          context.fillText(
            firstPart,
            startX + thirdPartWidth + 45,
            textYPosition
          );
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.fillText(
            secondPart,
            startX + thirdPartWidth + firstPartWidth + 55,
            textYPosition
          );

          const signature = new Image();
          signature.src = SignatureImage;

          await new Promise((resolve) => {
            signature.onload = resolve;
          });
          const targetWidth = 120;
          const targetHeight = 90;
          const signatureX = 40;
          const signatureY = 490;
          context.imageSmoothingEnabled = true;
          context.imageSmoothingQuality = "high";
          context.drawImage(
            signature,
            signatureX,
            signatureY,
            targetWidth,
            targetHeight
          );
          context.font = "400 14px Poppins";
          context.fillStyle = "#7c7b63";
          context.textAlign = "left";
          context.fillText(
            "Managing Director",
            signatureX + 16,
            signatureY + targetHeight + 10
          );

          textYPosition += 120;
          context.font = "400 12px Poppins";
          context.fillStyle = "#7c7b63";
          context.textAlign = "center";
          context.fillText("", canvas.width / 2, textYPosition);

          const barcodeContainer = document.createElement("div");
          document.body.appendChild(barcodeContainer);

          ReactDOM.render(
            <Barcode
              value={certificateId}
              width={1.5}
              height={50}
              fontSize={0}
              displayValue={false}
              background="transparent"
            />,
            barcodeContainer,
            () => {
              const svgElement = barcodeContainer.querySelector("svg");
              if (svgElement) {
                const svgData = new XMLSerializer().serializeToString(
                  svgElement
                );
                const img = new Image();
                img.src = "data:image/svg+xml;base64," + btoa(svgData);
                img.onload = () => {
                  const barcodeX = canvas.width - 210;
                  const barcodeY = 430;
                  const barcodeWidth = 180;
                  const barcodeHeight = 50;
                  context.drawImage(
                    img,
                    barcodeX,
                    barcodeY + 110,
                    barcodeWidth,
                    barcodeHeight
                  );
                  document.body.removeChild(barcodeContainer);
                };
              }
            }
          );
        };
      };
    }
  }, [courseName, name, date, certificateId]);
  return (
    <div
      style={{
        maxWidth: "100%",
        margin: "0 auto",
        textAlign: "center",
        borderRadius: "10px",
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          width: "100%",
          maxWidth: "200px",
          height: "auto",
          aspectRatio: "700 / 500",
          borderRadius: "10px",
        }}
      />
    </div>
  );
};

export default CertificateCanvas;
